
export function roundDecimal(num: number): number {
  return +(Math.round(Number(num + 'e+2')) + 'e-2');
}

export function randomInt(minimum: number, maximum: number): number {
  minimum = Math.ceil(minimum);
  maximum = Math.floor(maximum);
  return Math.floor(Math.random() * (maximum - minimum)) + minimum;
}
